import { render, staticRenderFns } from "./FojaConceptoPage.vue?vue&type=template&id=97addbd2"
import script from "./FojaConceptoPage.js?vue&type=script&lang=js&external"
export * from "./FojaConceptoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports